import React from 'react';

import { DataGrid, DataGridColumnDefinition } from 'components';
import { PayinOrder } from 'types';

type Props = {
  items: PayinOrder[];
  columns: DataGridColumnDefinition<PayinOrder>[];
};

export const OrderList: React.FC<Props> = ({ items, columns }) => (
  <DataGrid columns={columns} data={items} />
);
